import Phaser from 'phaser';

import { BlocksListener } from './blocks-listener';
import { GameController } from './controllers/game-controller';
import { GameServices } from './services/game-services';
import { TranslocoService } from '@jsverse/transloco';

export class BlocksApp {
  private static instance: BlocksApp;

  static getInstance(): BlocksApp {
    if (!BlocksApp.instance) {
      BlocksApp.instance = new BlocksApp();
    }
    return BlocksApp.instance;
  }

  public readonly gameController: GameController;

  private readonly gameServices: GameServices;

  private constructor() {
    this.gameServices = new GameServices();
    this.gameController = new GameController(this.gameServices);
  }

  public setGameListener(gameListener: BlocksListener) {
    this.gameServices.setGameListener(gameListener);
  }

  public preloadAssets(scene: Phaser.Scene, localAssetPath: string): void {
    this.gameServices.assetCatalogueService.preloadCatalogue(scene, localAssetPath);
  }

  public preloadTranslations(translocoService: TranslocoService): void {
    this.gameServices.gameTranslationService.preloadTranslations(translocoService);
  }
}
